// extracted by mini-css-extract-plugin
module.exports = {"blogCalculatorCta":"BlogCalculatorCta_blogCalculatorCta__NTnZo","head":"BlogCalculatorCta_head__RGotF","bgCta":"BlogCalculatorCta_bgCta__ERyfz"};